var _window$document;

import { useEffect, useLayoutEffect } from 'react';
var usePassiveLayoutEffect = typeof window !== 'undefined' && ((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.createElement) !== void 0 ? useLayoutEffect : useEffect;
export default usePassiveLayoutEffect;